import { ModalDefinirEnderecoDevolucaoController } from './modal-return-address/modal-return-address.controller'

(function () {
  'use strict';

  function myAddressControl() {

    function controller($rootScope, $scope, $state, $uibModal, $timeout, $mdToast, Endereco, Cep, localStorageService, Cliente, Pedido, Perfil) {

      var addressControl = this;
      // addressControl.remetente = !Perfil.getCacheUserData() || !Perfil.getCacheUserData().nome ? null : Perfil.getCacheUserData().nome;
      addressControl.nome = '';
      addressControl.remetente = '';

      var indexActive = null;

      var listLoaded = false;

      var dentroDaArea = null;

      // variavel utilizada para esconder e exibir o bloco de add endereço
      addressControl.addItemActive = true;

      addressControl.loading = false;

      // objeto de endereco novo
      addressControl.coleta = {};
      addressControl.etiqueta = {};

      // variavel de exibição pós exibição de area
      addressControl.verifyArea = false;
      addressControl.areaAtendimento = null;
      addressControl.tipoColeta = null;

      // Seta booleano para usar etiqueta ou nao
      addressControl.choseTag = false;

      // variavel com o item ativo
      addressControl.itemActive = null;

      // variavel com o endereco de devolução
      addressControl.itemReturn = null;

      // add ou remove item do array de endereco
      function addItemActiveArray(index, item) {
        $scope.addressList.splice(index, 0, item);
      }

      function removeItemArray(index) {
        $scope.addressList.splice(index, 1);
      }

      function updateAddress(id) {
        if (addressControl.itemActive) {
          addressControl.itemActive.ativo = false;
          addItemActiveArray(indexActive, addressControl.itemActive);
        }
        for (var i = 0; i < $scope.addressList.length; i++) {
          if ($scope.addressList[i].id === id) {
            $scope.addressList[i].ativo = true;
            addressControl.itemActive = $scope.addressList[i];
            indexActive = i;
            updateAddressLS($scope.addressList);
            Perfil.updateAddress($scope.addressList);
            // remove item selecionado
            removeItemArray(i);
            break;
          } else {
            $scope.addressList[i].ativo = false;
          }
        }
        return $scope.addressList;
      }

      function getActiveAddress() {
        for (var i = 0; i < $scope.addressList.length; i++) {
          if ($scope.addressList[i].ativo == true) {
            addressControl.itemActive = $scope.addressList[i];
            indexActive = i;
            removeItemArray(i);
            $rootScope.$broadcast('etiqueta:remetente:alterado', addressControl.itemActive);
            break;
          }
        }
      }

      function getReturnAddress() {
        addressControl.itemReturn = $scope.addressList.find(address => address.enderecoDeDevolucao === true) ||
          $scope.addressList.find(address => address.ativo === true);
      }

      function deleteAddress(id) {
        for (var i = 0; i < $scope.addressList.length; i++) {
          if ($scope.addressList[i].id === id) {
            startEndLoading();
            return $scope.addressList.splice(i, 1);
          }
        }
      }

      function addAddress(listaEnderecos) {
        $scope.addressList = listaEnderecos;
        getReturnAddress();
        getActiveAddress();
      }

      function showAlert(content) {
        var toast = $mdToast.simple()
          .textContent(content)
          .highlightAction(true)
          .parent('[data-container="toast"]')
          .position('top right')
          .hideDelay(5000);

        return $mdToast.show(toast);
      }

      function showBackMsg(msg) {
        var modalInstance = $uibModal.open({
          animation: false,
          template: require('./modal-msg/modal-msg.html'),
          controller: 'ModalMsgController as modalMsg',
          resolve: {
            msgBackEnd: function () {
              return msg;
            }
          }
        })
      }

      function deleteItem(id) {
        var idAddress = id;
        Endereco.deleteAddress(id)
          .then(function (deletedAddress) {
            deleteAddress(idAddress);
            scrollToTop();
            addressControl.exibeMsgSucesso = false;
            addressControl.mensagemSucesso = 'Endereço de coleta excluído com sucesso.';
            $timeout(function () {
              addressControl.exibeMsgSucesso = true;
            }, 500);
          })
          .catch(function (err) {
            showBackMsg(err.data.error.message);
            startEndLoading();
          });
      }

      function updateReturnAddress(id) {
        Endereco.updateReturnAddress(id)
          .then(function () {
            addressControl.itemReturn.enderecoDeDevolucao = false;

            if (addressControl.itemActive.id === id) {
              addressControl.itemReturn = addressControl.itemActive;
              addressControl.itemActive.enderecoDeDevolucao = true;
              updateAddress(id);
            } else {
              addressControl.itemReturn = $scope.addressList.find(address => address.id === id);
              addressControl.itemReturn.enderecoDeDevolucao = true;
            }
            startEndLoading();
            scrollToTop();
            addressControl.mensagemSucesso = 'Endereço de devolução atualizado com sucesso.';
            addressControl.exibeMsgSucesso = true;
          })
          .catch(function (err) {
            showBackMsg(err.data.error.message);
            startEndLoading();
          });
      }

      function chooseImg(area) {
        if (area.diaAdicional > 0) {
          return '/assets/images/icone_area_de_coleta_D+1.svg';
        } else if (area == 'fora de area') {
          return '/assets/images/icone_area_de_coleta_fora_da_area.svg';
        }
      }

      function updateAddressLS(addressList) {
        Cliente.atualizarEnderecoAtivo(addressList);
        Pedido.atualizarEnderecoPedido(addressList);
      }

      function focusBlankField(item, fieldName) {
        for (var i in item) {
          if (item[i] === '') {
            var nameElement = i + (fieldName ? fieldName : '');
            $timeout(function () {
              document.querySelector('input[name=' + nameElement + ']').focus();
            }, 100);
            break;
          }
        }
      }

      function startEndLoading() {
        addressControl.loading = !addressControl.loading;
      }

      function scrollToTop() {
        $("html, body").animate({scrollTop: 0});
      }

      // funções publicas
      addressControl.addItem = function () {
        addressControl.addItemActive = !addressControl.addItemActive;
      };

      // funções publicas para ativar e excluir endereço
      addressControl.resetComponent = function () {
        addressControl.remetente = ''; // reseta campo de remetente
        addressControl.addItemActive = true; // reseta variavel de exibição para add
        addressControl.verifyArea = false; // reseta variavel de exibição para verificar area
        addressControl.areaAtendimento = null; // reseta exibição do mapa de dentro ou fora da area
        addressControl.choseTag = false; // reseta opção de utilizar etiqueta

        // reseta forms
        angular.element('.autofill-coleta').val(null);
        angular.copy({}, addressControl.coleta);
        angular.copy({}, addressControl.etiqueta);
        // seta forms no estado inicial
        addressControl.formEnderecoColeta.$setPristine();
        addressControl.formEnderecoEtiqueta.$setPristine();
      };

      addressControl.activateItem = function (item) {

        if (!item.coletaHabilitada)
          return;

        var id = item.id;
        startEndLoading();
        Endereco.activateAddress(id)
          .then(function () {
            updateAddress(id);
            startEndLoading();
            scrollToTop();
            addressControl.exibeMsgSucesso = false;
            $timeout(function () {
              addressControl.exibeMsgSucesso = true;
            }, 500);
            addressControl.mensagemSucesso = 'Endereço de coleta atual atualizado com sucesso.';
          })
          .catch(function (err) {
            showBackMsg(err.data.error.message);
            startEndLoading();
          });
      };

      addressControl.saveItem = function () {
        if (addressControl.formEnderecoColeta.$valid && (addressControl.etiqueta.endereco == null || angular.equals(addressControl.etiqueta.endereco, {}) || addressControl.formEnderecoEtiqueta.$valid)) {

          var comMesmoNome = $scope.addressList.concat(addressControl.itemActive).filter(function (address) {
            return address && address.nome == addressControl.nome;
          });

          if (comMesmoNome && comMesmoNome.length > 0) {
            showAlert("O nome do endereço deve ser único");
            return;
          }

          var enderecoEtiqueta = addressControl.etiqueta.endereco == null || angular.equals(addressControl.etiqueta.endereco, {}) ? null : {
            "logradouro": addressControl.etiqueta.endereco.logradouro,
            "bairro": addressControl.etiqueta.endereco.bairro,
            "cep": addressControl.etiqueta.endereco.cep,
            "cidade": addressControl.etiqueta.endereco.cidade,
            "numero": addressControl.etiqueta.endereco.numero,
            "complemento": addressControl.etiqueta.endereco.complemento,
            "uf": addressControl.etiqueta.endereco.estado,
            "remetente": addressControl.remetenteEtiqueta
          };

          var endereco = {
            "nome": addressControl.nome,
            "logradouro": addressControl.coleta.endereco.logradouro,
            "bairro": addressControl.coleta.endereco.bairro,
            "cep": addressControl.coleta.endereco.cep,
            "cidade": addressControl.coleta.endereco.cidade,
            "numero": addressControl.coleta.endereco.numero,
            "complemento": addressControl.coleta.endereco.complemento,
            "uf": addressControl.coleta.endereco.estado,
            "remetente": addressControl.remetente,
            "etiqueta": enderecoEtiqueta,
            "coletaHabilitada": addressControl.coleta.coletaHabilitada,
            "logisticaReversaHabilitada": addressControl.coleta.logisticaReversaHabilitada,
            "devolucaoHabilitada" : addressControl.coleta.devolucaoHabilitada
          };

          Endereco.addAddress(endereco, dentroDaArea)
            .then(function (listaEnderecos) {
              addressControl.resetComponent();
              Cliente.atualizarEnderecoAtivo(listaEnderecos);
              Pedido.atualizarEnderecoPedido(listaEnderecos);
              addAddress(listaEnderecos);
              addressControl.exibeMsgSucesso = false;
              $timeout(function () {
                addressControl.exibeMsgSucesso = true;
              }, 500);
              addressControl.mensagemSucesso = 'Endereço adicionado e atualizado com sucesso.';
            })
            .catch(function (err) {
              showBackMsg(err.data.error.message);
            });
        } else {
          addressControl.formEnderecoColeta.$setSubmitted();
          addressControl.formEnderecoEtiqueta.$setSubmitted();
        }
      };

      addressControl.showDeleteModal = function (id) {
        startEndLoading();
        var idItem = id;
        $uibModal.open({
          animation: false,
          template: require('./modal-delete/modal-delete.html'),
          controller: 'ModalExcluirEnderecoController as modalExcluir',
          resolve: {
            deletarEndereco: false,
            idItem: idItem
          }
        })
          .result
          .then(function (objExcluir) {
            deleteItem(objExcluir.id);
          });
      };

      addressControl.showReturnAddressModal = function (id) {
        startEndLoading();
        $uibModal.open({
          animation: false,
          template: require('./modal-return-address/modal-return-address.html'),
          controller: ModalDefinirEnderecoDevolucaoController,
          controllerAs: 'modalDefinirDevolucao',
        }).result
          .then(function() {
            updateReturnAddress(id);
          });
      };

      addressControl.updateTag = function () {
        var sender = addressControl.choseTag ? addressControl.etiqueta : addressControl.coleta;
        $rootScope.$broadcast('etiqueta:remetente:alterado', sender);

        if (!addressControl.choseTag) {
          angular.copy({}, addressControl.etiqueta.endereco);
          angular.element('.autofill-etiqueta').val(null);
        }
      };

      addressControl.fillAddress = function (item) {
        addressControl.verifyArea = false;
        addressControl.areaAtendimento = null;
        addressControl.coleta.coletaHabilitada = true;
        addressControl.coleta.logisticaReversaHabilitada = true;
        Cep.buscarTipoVeiculoPorCepDadosColeta(item.cep)
          .then(function (area) {
            // exibe informação de area D+1 e etc...
            addressControl.verifyArea = true;
            focusBlankField(item);
            if (area.diaAdicional > 0) {
              addressControl.areaAtendimento = area;
              addressControl.tipoColeta = chooseImg(area);
            }
            dentroDaArea = true;
          })
          .catch(function (err) {
            // exibe informação de fora de area
            if (err.status == 404) {
              addressControl.verifyArea = true;
              focusBlankField(item);
              addressControl.areaAtendimento = {observacaoCadastro: 'A Mandaê ainda não realiza coletas no endereço informado. Estamos nos esforçando para alcançar as novas áreas em breve.'};
              addressControl.tipoColeta = chooseImg('fora de area');
              dentroDaArea = false;
              addressControl.coleta.coletaHabilitada = false;
            }
          });
      };

      addressControl.focusField = function (item) {
        focusBlankField(item, 'Etiqueta');
      };

      addressControl.backOrigem = function () {
        if ($scope.origem) {
          $state.go($scope.origem);
        }
      };

      $scope.$watch('addressList', function () {
        if ($scope.addressList && !listLoaded) {
          getReturnAddress();
          getActiveAddress();
          listLoaded = true;
        }
      });
    }

    var config = {
      restrict: 'E',
      replace: true,
      transclude: true,
      scope: {
        addressList: '=',
        origem: '='
      },
      template: require('./address-control.html'),
      controller: ['$rootScope', '$scope', '$state', '$uibModal', '$timeout', '$mdToast', 'Endereco', 'Cep', 'localStorageService', 'Cliente', 'Pedido', 'Perfil', controller],
      controllerAs: 'addressControl'
    };

    return config;
  }

  angular
    .module('mandaeApp')
    .directive('myAddressControl', myAddressControl)

})();
